import { summarizeSession, type SessionSummary } from "../lib/sessionSummary";
import { useHistoryStore } from "./historyStore";
import { useSessionStore } from "./sessionStore";

/**
 * The one hook that turns the history log plus the session boundary into
 * this sitting's numbers. Both the session summary strip and the book
 * recommendation's milestone read it, so "ten rounds in" means exactly the
 * number the strip prints: one derivation over one log, never a second
 * counter kept alongside it.
 */
export function useSessionSummary(): SessionSummary {
  const entries = useHistoryStore((s) => s.entries);
  const startedAt = useSessionStore((s) => s.startedAt);
  return summarizeSession(entries, startedAt);
}
